/**
 * Generates a unique, stable cache key (ID) for a given selection.
 *
 * This key is used as the primary identifier in the database for a translation record.
 * It's designed to be unique for each distinct selection, whether it's from
 * a text or a PDF source.
 *
 * @param selection The unified selection data object.
 * @param documentIdentity The identifier of the document the selection belongs to.
 * @returns A unique string key for the selection.
 */
export const generateCacheKey = (selection, documentIdentity) => {
    const docId = documentIdentity.id;
    const docType = documentIdentity.type;
    switch (selection.type) {
        case 'text': {
            const { paragraphData, startOffset, endOffset } = selection.location;
            // Key for text: docType:docId:paragraphId:start:end
            const key = `${docType}:${docId}:${paragraphData.id}:${startOffset}:${endOffset}`;
            return key;
        }
        case 'pdf': {
            const { paragraphId, startWordId, endWordId, startWordOffset, endWordOffset } = selection.location;
            // Key for PDF: docType:docId:paragraphId:startWord:startOffset:endWord:endOffset
            const key = `${docType}:${docId}:${paragraphId}:${startWordId}:${startWordOffset}:${endWordId}:${endWordOffset}`;
            return key;
        }
        default: {
            // Fallback for exhaustive check, should not be reached
            const unhandled = selection;
            console.error('Unhandled selection type in generateCacheKey', unhandled);
            // Generate a random key in production to prevent crashes, though this indicates an issue.
            const errorKey = `error:${Date.now()}:${Math.random()}`;
            return errorKey;
        }
    }
};
//# sourceMappingURL=cacheKeyUtils.js.map